/**
 * The tint a wine of a grape usually shows in the glass, one per grape code of the grape lexicon:
 * proef's own table, distilled from public winemaking and sommelier references (high and medium
 * confidence, or sourced), restated in our tint vocabulary. Data only: add or correct a line here
 * and nothing else changes. A tint must belong to the colour of the wine it is used for
 * (HUES_BY_COLOUR), or it is ignored.
 */
import type { Hue } from "../scales.js";

export const LOOK_ESTIMATES: Readonly<Record<string, Hue>> = {
  "pinot-noir": "ruby",
  gamay: "ruby",
  "cabernet-sauvignon": "ruby",
  merlot: "ruby",
  syrah: "ruby",
  tempranillo: "ruby",
  grenache: "ruby",
  sangiovese: "ruby",
  nebbiolo: "ruby",
  malbec: "purple",
  "cabernet-franc": "ruby",
  "petit-verdot": "purple",
  tannat: "purple",
  zinfandel: "ruby",
  carmenere: "ruby",
  pinotage: "purple",
  mourvedre: "ruby",
  "touriga-nacional": "purple",
  aglianico: "ruby",
  "nero-d-avola": "ruby",
  corvina: "ruby",
  chardonnay: "gold",
  "sauvignon-blanc": "lemon",
  riesling: "lemon",
  "pinot-gris": "lemon",
  "pinot-blanc": "lemon",
  "chenin-blanc": "gold",
  viognier: "gold",
  gewurztraminer: "gold",
  albarino: "lemon",
  vermentino: "lemon",
  verdicchio: "lemon",
  "gruner-veltliner": "lemon",
  muscat: "gold",
  semillon: "gold",
  trebbiano: "lemon",
  garganega: "lemon",
  cortese: "lemon",
  friulano: "lemon",
  assyrtiko: "lemon",
  rkatsiteli: "lemon",
  godello: "gold",
  verdejo: "gold",
  malvasia: "gold",
  marsanne: "gold",
  roussanne: "gold",
  torrontes: "gold",
  "muller-thurgau": "lemon",
  "melon-de-bourgogne": "lemon",
  "petite-sirah": "ruby",
  barbera: "ruby",
  montepulciano: "ruby",
  xinomavro: "ruby",
  blaufrankisch: "ruby",
  dornfelder: "purple",
  mencia: "ruby",
  arneis: "lemon",
  bacchus: "gold",
  "pedro-ximenez": "brown",
  palomino: "lemon",
};
